import ProjectCard from './ProjectCard'
import projects from '../data/projects'

const ProjectsMain = () => {

    return (
      <>
        <p className="eyebrow">Projects</p>
        <h1 className="page-title">Things I've built</h1>
        <p className="lede">Apps and sites I've designed and built, from idea through to release.</p>
        <div className="project-grid section-sm">
            {projects.map(project => <ProjectCard project = {project} key = {project.id}/>)}
        </div>
      </>
    );
}

export default ProjectsMain;
